import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const { server_url: serverUrl } = config[env]

export const state = {
}

export const getters = {
}

export const mutations = {
}

export const actions = {
  fetchOutsideWorkReportDetail(_, params) {
    return axios.get(`${serverUrl}/reports/outside_work_report_detail/`, { params: params })
  },
  fetchOutsideWorkReportDetailDimensionsAandB(_, params) {
    return axios.get(`${serverUrl}/reports/outside_work_report_detail_AandB/custom_total_dimensions/?${params}`)
  },
  fetchOutsideWorkReportDetailGeneralAandB(_, params) {
    return axios.get(`${serverUrl}/reports/outside_work_report_detail_AandB/custom_total_general/?${params}`)
  },
}